import './styles.scss';
import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import i18n from 'utils/translate';
import { TRAVEL_FILTERS } from 'utils/constants';
import { formatPrice } from 'utils/common';
import ItemTitle from '../ItemTitle';
import QuestionMark from 'components/QuestionMark';

const propTypes = {
  className: PropTypes.string,
  finalPrice: PropTypes.number,
  currency: PropTypes.string,
  bookingDate: PropTypes.any,
  sections: PropTypes.shape({
    type: PropTypes.oneOf([TRAVEL_FILTERS.SINGLE, TRAVEL_FILTERS.FAMILY]),
    destination: PropTypes.oneOf([TRAVEL_FILTERS.INLAND, TRAVEL_FILTERS.FOREIGN]),
    bikeType: PropTypes.string,
    bikePrice: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    cancellation: PropTypes.bool,
    ebike: PropTypes.bool,
    eventType: PropTypes.string,
    insuranceSum: PropTypes.string,
    eventDate: PropTypes.any,
    eventLocation: PropTypes.string,
    schoolAndClass: PropTypes.string,
    job: PropTypes.string,
    groups: PropTypes.any,
    fields: PropTypes.string,
    court: PropTypes.string,
    recordDate: PropTypes.string,
    association: PropTypes.string,
    paymentType: PropTypes.string,
    riskDeclined: PropTypes.bool,
    riskDamage: PropTypes.bool
  }),
  title: PropTypes.string.isRequired,
  bike: PropTypes.bool,
  expertInterpreter: PropTypes.bool,
  quoteType: PropTypes.oneOf(['annual', 'once'])
};
const defaultProps = {
  className: '',
  title: i18n('Default title'),
  sections: {
    type: null,
    destination: null,
    bikeType: null,
    bikePrice: null,
    startDate: null,
    endDate: null,
    cancellation: null,
    eBike: null,
    eventType: null,
    insuranceSum: null,
    eventDate: null,
    eventLocation: null,
    schoolAndClass: null,
    job: null,
    groups: null,
    fields: null,
    court: null,
    recordDate: null,
    association: null,
    paymentType: null,
    riskDeclined: null,
    riskDamage: null
  },
  bookingDate: null,
  finalPrice: null,
  bike: false,
  expertInterpreter: false,
  quoteType: 'annual'
};

class SummaryBox extends Component {
  render() {
    const { className, finalPrice, sections, title, currency, bike, bookingDate, expertInterpreter, quoteType } =
      this.props;

    return (
      <div className={`summary-box-wrapper ${className}`}>
        <div className="summary-box-wrapper__title">{title}</div>
        <div className="sections-wrapper">
          {/* Variante */}
          {sections.type != null && (
            <div className="section">
              <ItemTitle
                text={i18n('Variante')}
                questionMark={i18n(
                  'Die Familienversicherung gilt für maximal 2 Erwachsene und 5 minderjährige Personen, unabhängig vom Verwandtschaftsgrad. Ein gemeinsamer Wohnsitz ist nicht erforderlich.'
                )}
              />
              <div>
                <span className="sections-wrapper__text">
                  {sections.type === TRAVEL_FILTERS.FAMILY ? i18n('Familienversicherung') : i18n('Einzelversicherung')}
                </span>
              </div>
            </div>
          )}

          {/* Destination */}
          {sections.destination != null && (
            <div className="section">
              <ItemTitle text={i18n('Destination')} />
              <div>
                <span className="sections-wrapper__text">
                  {sections.destination === TRAVEL_FILTERS.INLAND ? (
                    <span>
                      {i18n('Inland')}
                      <QuestionMark
                        content={i18n(
                          'Eine Inlandsreise findet in Österreich statt (siehe Punkt 1.2. der Allgemeinen Bedingungen für die Reiseversicherung).'
                        )}
                      />
                    </span>
                  ) : (
                    <span>
                      {i18n('Ausland')}
                      <QuestionMark
                        content={i18n(
                          'Der Versicherungsschutz gilt weltweit, exkl. Iran, Nordkorea, der Krim, Syrien und Venezuela.'
                        )}
                      />
                    </span>
                  )}
                </span>
              </div>
            </div>
          )}

          {/* Bike Type && E-Bike */}
          {sections.ebike != null && (
            <div className="section">
              <ItemTitle text={i18n('E-Bike')} />
              <div>
                <span className="sections-wrapper__text">{sections.ebike ? i18n('Ja') : i18n('Nein')}</span>
              </div>
            </div>
          )}

          {/* New Price */}
          {sections.bikePrice != null && (
            <div className="section">
              <ItemTitle text={i18n('Neupreis inkl. Zubehör')} />
              <div>
                <span className="sections-wrapper__text">{formatPrice(sections.bikePrice, currency)}</span>
              </div>
            </div>
          )}

          {/* Expert Details */}
          {expertInterpreter && (
            <div className="section">
              <ItemTitle text={i18n('Details zur Tätigkeit')} />
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Beruf')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.job}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Fachgruppe(n)')}:&nbsp;
                  <div className="sections-wrapper__list">
                    <ul>
                      {sections.groups &&
                        sections.groups.map((group, index) => (
                          <li>
                            {group}
                            {index !== sections.groups.length - 1 && ','}
                          </li>
                        ))}
                    </ul>
                  </div>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Fachgebiet(e)')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.fields}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Gericht der Eintragung')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.court}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Datum der Eintragung')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.recordDate.format('DD.MM.YYYY')}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Mitgliedschaft Landesverband')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.association || i18n('Nein')}</span>
                </span>
              </div>
            </div>
          )}

          {/* Date */}
          {sections.startDate != null && (
            <div className="section">
              {bike || expertInterpreter ? (
                <ItemTitle text={i18n('Versicherungsdauer')} />
              ) : (
                <ItemTitle
                  text={i18n('Reisezeitraum')}
                  questionMark={i18n(
                    'Die Reiseversicherung muss vor Reiseantritt abgeschlossen werden! Der Versicherungszeitraum beträgt maximal 365 Tage.'
                  )}
                />
              )}
              <div>
                <span className="sections-wrapper__text">{sections.startDate}</span>
                <span className="sections-wrapper__text">{sections.endDate}</span>
              </div>
            </div>
          )}

          {/* Cancellation */}
          {sections.cancellation != null && (
            <div className="section">
              <ItemTitle text={i18n('Stornoschutz')} />
              <div>
                <span className="sections-wrapper__text">
                  {sections.cancellationAddDays
                    ? `${i18n('Ab')} ${moment().add(10, 'days').format('DD.MM.YYYY')}`
                    : sections.cancellation
                      ? i18n('Ja')
                      : i18n('Nein')}
                </span>
              </div>
            </div>
          )}

          {sections.cancellation && sections.bookingDate != null && (
            <div className="section">
              <ItemTitle text={i18n('Buchungsdatum')} />
              <div>
                <span className="sections-wrapper__text">{bookingDate.format('DD.MM.YYYY')}</span>
              </div>
            </div>
          )}

          {/* Event Type */}
          {sections.eventType != null && (
            <div className="section">
              <ItemTitle text={i18n('Art der Veranstaltung')} />
              <div>
                <span className="sections-wrapper__text">{sections.eventType}</span>
              </div>
            </div>
          )}

          {/* Insurance sum */}
          {sections.insuranceSum != null && (
            <div className="section">
              <ItemTitle text={i18n('Versicherungssumme')} />
              <div>
                <span className="sections-wrapper__text">{sections.insuranceSum}</span>
              </div>
            </div>
          )}

          {/* Event Details */}
          {(sections.eventDate != null || sections.eventLocation != null || sections.schoolAndClass != null) && (
            <div className="section">
              <ItemTitle text={i18n('Details zur Veranstaltung')} />
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Veranstaltungsdatum')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.eventDate.format('DD.MM.YYYY')}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Veranstaltungsort')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.location}</span>
                </span>
              </div>
              <div>
                <span className="sections-wrapper__text">
                  {i18n('Schule und Klasse')}:&nbsp;
                  <span className="sections-wrapper__value">{sections.schoolAndClass}</span>
                </span>
              </div>
            </div>
          )}

          {finalPrice && (
            <div className="sections-wrapper__price">
              <div className="sections-wrapper__quote">
                <ItemTitle text={i18n(`Prämie (${quoteType === 'annual' ? 'jährlich' : 'einmalig'})`)} />
                <span className="sections-wrapper__final-price">{formatPrice(finalPrice, currency)}</span>
              </div>
              {(expertInterpreter || bike) && sections.paymentType}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SummaryBox.propTypes = propTypes;
SummaryBox.defaultProps = defaultProps;

export default SummaryBox;
